import { DashboardStore } from "src/app/dashboard/dashboard.store";
import { WorkspacesService } from "../../main/accountant/workspaces.service";
import { MessageBubbleService } from "./message-bubble.service";
import { ChatService } from "../../chat.service";
import {
  Component,
  OnInit,
  Input,
  ElementRef,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  AfterViewInit,
  ViewChild,
  TemplateRef,
} from "@angular/core";
import { ConversationsService } from "../conversations.service";
import { DomSanitizer } from "@angular/platform-browser";
import { Router } from "@angular/router";
import { JobsService } from "../../main/accountant/jobs-and-tasks/jobs.service";
import { Job, Task } from "../../main/accountant/jobs-and-tasks/job.model";
import { HotToastService } from "@ngneat/hot-toast";
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import { NgxLinkifyjsService, NgxLinkifyjsModule } from "ngx-linkifyjs-v2";
import { JobsStore } from "../../main/accountant/jobs-and-tasks/jobs.store";
import { LocalStorageService } from "src/app/utils/localstorage.service";
import { AssistantService } from "../../ai-assistant/assistant.service";
import { ShowOwnerNamesPipe } from "./show-names.pipe";
import { MomentModule } from "ngx-moment";
import { PickerComponent } from "@ctrl/ngx-emoji-mart";
import { BsDropdownModule } from "ngx-bootstrap/dropdown";
import { AutosizeModule } from "ngx-autosize";
import { FormsModule } from "@angular/forms";
import { EmojiComponent } from "@ctrl/ngx-emoji-mart/ngx-emoji";
import { NgClass } from "@angular/common";
import { SecuredImageComponent } from "../../../shared/secured-image.component";
import { FilePreviewDirective } from "../../main/common/file-preview.directive";
import { TooltipModule } from "ngx-bootstrap/tooltip";
import { PinComponent } from "src/app/design-system/components/pin/pin.component";
import { PinnedModels } from "../../main/accountant/pinned-panel/pinned-models";

@Component({
  selector: "message-bubble",
  templateUrl: "./message-bubble.component.html",
  styleUrls: ["./message-bubble.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    TooltipModule,
    FilePreviewDirective,
    SecuredImageComponent,
    NgClass,
    EmojiComponent,
    FormsModule,
    AutosizeModule,
    BsDropdownModule,
    PickerComponent,
    MomentModule,
    NgxLinkifyjsModule,
    ShowOwnerNamesPipe,
    PinComponent,
  ],
})
export class MessageBubbleComponent implements OnInit, AfterViewInit {
  @Input() message: any;
  @Input() user: any;
  @Input() is_comment: any;
  @Input() isBotMessageEnabled: any;
  @Input() conversation_uuid: any;
  @Input() isLast: boolean = false;
  @Input() isSearchMode: boolean = false;
  @Input() disabled: boolean = false;
  @Input() company_uuid: string;
  @Input() origin: "conversation" | "client-task" | "job" | "file" | undefined =
    "conversation";

  @ViewChild("notProMessage") notProMessage: any;

  @ViewChild("removePinModal") removePinModal: TemplateRef<any>;

  bubbleClass = "";
  replyBubbleClass = "";
  ext: any = null;
  data: any = {};

  pinModel = PinnedModels.Message;
  old_message = "";

  loadingPin = false;

  moment_calendar_format = {
    sameDay: "h:mm A",
    nextDay: "[Tomorrow]",
    nextWeek: "dddd",
    lastDay: "[Yesterday -] H:mm A",
    lastWeek: "[Last] dddd",
    sameElse: "h:mm A - MMM D",
  };

  fileImageExtensions = ["jpg", "jpeg", "gif", "png", "bmp"];
  replyingTo: any = {};

  bsModalRef: BsModalRef;

  hovering = false;
  pinStatus = ""; // "", "pinned", "done"

  emojiConfig = {
    style: {
      position: "absolute",
      width: "300px",
      "z-index": "1",
      height: "300px",
      overflow: "hidden",
      "border-radius": "16px",
      "font-family": "Figtree",
    },
    set: "apple",
    sheetSize: 32,
    include: ["search", "recent", "people", "activity"],
    darkMode: false,
    i18n: {
      search: "Search",
      emojilist: "List of emoji",
      notfound: "No Emoji Found",
      clear: "Clear",
      categories: {
        search: "Search Results",
        recent: "Frequently Used",
        people: "Smileys & People",
      },
    },
  };

  constructor(
    private conversationsService: ConversationsService,
    public _sanitizer: DomSanitizer,
    private cdr: ChangeDetectorRef,
    private chatService: ChatService,
    private localStorage: LocalStorageService,
    private router: Router,
    private jobsService: JobsService,
    private toastr: HotToastService,
    public dashboardStore: DashboardStore,
    private linkifyService: NgxLinkifyjsService,
    private modalService: BsModalService,
    private jobsStore: JobsStore,
    private aiAssistantService: AssistantService,
  ) {}

  replaceAll(string, str1, str2, ignore) {
    return string.replace(
      new RegExp(
        str1.replace(/([\/\,\!\\\^\$\{\}\[\]\(\)\.\*\+\?\|\<\>\-\&])/g, "\\$&"),
        ignore ? "gi" : "g",
      ),
      typeof str2 == "string" ? str2.replace(/\$/g, "$$$$") : str2,
    );
  }

  ngOnInit(): void {
    if (this.message.tracked_item != null) {
      if (
        this.message.tracked_item !== null &&
        this.message.tracked_item.answer_filename !== null
      ) {
        this.ext = this.getFileExt(this.message.tracked_item.answer_filename);
      }
    }

    this.data = this.localStorage.get("data");

    this.handleBubbleClass();

    if (this.is_comment) {
      // THIS IS THE BIGGEST GAMBIARRA IVE EVER DONE:
      if (!this.message.message.includes("Original response from")) {
        this.message.message = this.linkifyService.linkify(
          this.message.message,
        );
      }

      this.message.message = this.replaceAll(
        this.message.message,
        "&lt;",
        "<",
        true,
      );

      this.message.message = this.replaceAll(
        this.message.message,
        "&gt;",
        ">",
        true,
      );
    }

    // this.cdr.detach(); // deactivate change detection
    // setInterval(() => {
    //   this.cdr.detectChanges(); // manually trigger change detection
    // }, 100);
  }

  ngAfterViewInit(): void {}

  sanitize(image) {
    return this._sanitizer.bypassSecurityTrustUrl(`${image}`);
  }

  async goToTrackedItem(trackedItemUuid) {
    let trackedItem =
      await this.conversationsService.get_tracked_item(trackedItemUuid);

    this.dashboardStore.selectTrackedItem(
      trackedItem,
      this.dashboardStore.currentCompany,
    );
  }

  goToOpenTrackedItems(): void {
    this.conversationsService.showOpenTrackedItems.next({});
  }

  getFileExt(filename) {
    if (filename !== undefined && filename !== null) {
      return filename.split(".")[1];
    } else {
      return null;
    }
  }

  editMessage(message) {
    this.old_message = message.message;
    this.cdr.markForCheck();
    message["edit_mode"] = true;
    this.cdr.detectChanges();
  }

  addReaction({ emoji }) {
    if (!this.message.reactions) {
      this.message.reactions = [];
    }

    const { reactions } = this.message;
    const user = this.localStorage.get("user");
    const existingReactionIdx = reactions.findIndex(
      ({ emoji_obj }) => emoji_obj.id === emoji.id,
    );

    if (existingReactionIdx !== -1) {
      const hasAlreadyReacted = reactions[existingReactionIdx].owners.some(
        ({ id }) => id === user.id,
      );
      if (hasAlreadyReacted) return;

      reactions[existingReactionIdx].owners.push(user);
    } else {
      reactions.push({
        emoji_obj: emoji,
        owners: [user],
      });

      this.cdr.markForCheck();
      this.chatService.changeReactions(this.message, this.conversation_uuid);
      this.cdr.detectChanges();
    }
  }

  handleReactionClick(reaction) {
    const user = this.localStorage.get("user");
    const { reactions } = this.message;
    const hasAlreadyReactedIdx = reactions.findIndex(
      ({ owners, emoji_obj }) =>
        owners.some(({ id }) => id === user.id) &&
        emoji_obj.id === reaction.emoji_obj.id,
    );

    if (hasAlreadyReactedIdx !== -1) {
      const filteredReactions = reactions[hasAlreadyReactedIdx].owners.filter(
        ({ id }) => id !== user.id,
      );
      reactions[hasAlreadyReactedIdx].owners = filteredReactions;

      if (reactions[hasAlreadyReactedIdx].owners.length === 0) {
        this.message.reactions = reactions.filter(
          ({ emoji_obj }) =>
            emoji_obj.id !== reactions[hasAlreadyReactedIdx].emoji_obj.id,
        );
      }

      this.cdr.markForCheck();
      this.chatService.changeReactions(this.message, this.conversation_uuid);
      this.cdr.detectChanges();
      return;
    }

    this.addReaction({ emoji: reaction.emoji_obj });
  }

  editMessageConfirm(message) {
    switch (this.origin) {
      case "conversation":
        this.editConversationMessage(message);
        break;
      case "client-task":
        this.editClientTaskMessage(message);
        break;
    }
  }

  editConversationMessage(message: any) {
    this.cdr.markForCheck();
    this.chatService.editMessage(
      message,
      this.old_message,
      this.conversation_uuid,
    );
    this.aiAssistantService.updatePineconeMessage(message);
    this.cdr.detectChanges();
  }

  editClientTaskMessage(comment: any) {
    this.cdr.markForCheck();
    this.conversationsService
      .editTrackedItemComment(comment.id, comment.message)
      .subscribe({
        next: () => {
          comment["edit_mode"] = false;
          comment.is_edited = true;
        },
        error: (e) => {
          console.error(e);
          this.toastr.error("Failed to edit message");
        },
        complete: () => this.cdr.detectChanges(),
      });
  }

  cancelEdit(message) {
    this.cdr.markForCheck();
    message.message = this.old_message;
    message["edit_mode"] = false;
    this.old_message = "";
    this.cdr.detectChanges();
  }

  deleteMessage(message) {
    this.cdr.markForCheck();
    this.chatService.deleteMessage(message, this.conversation_uuid);
    this.cdr.detectChanges();
  }

  toggleMessageVisibility(message) {
    switch (this.origin) {
      case "conversation":
        this.toggleConversationMessageVisibility(message);
        break;
      case "client-task":
        this.toggleClientTaskMessageVisibility(message);
        break;
      default:
        this.toastr.warning("Failed to delete resource");
    }
  }

  toggleConversationMessageVisibility(message: any) {
    this.cdr.markForCheck();
    this.chatService.toggleMessageVisibility(message, this.conversation_uuid);
    this.message.deleted = !this.message.deleted;
    this.aiAssistantService.updatePineconeMessage(
      message,
      this.message.deleted,
    );
    this.cdr.detectChanges();
  }

  toggleClientTaskMessageVisibility(message: any) {
    this.cdr.markForCheck();
    if (!message.is_deleted) {
      this.conversationsService.deleteTrackedItemComment(message.id).subscribe({
        next: () => (message.is_deleted = true),
        error: () => this.toastr.error("Failed to delete message"),
        complete: () => {
          this.cdr.detectChanges();
          console.log("toggleClientTaskMessageVisibility, complete");
        },
      });
    } else {
      this.conversationsService
        .restoreTrackedItemComment(message.id)
        .subscribe({
          next: (n: any) => {
            message.message = n.message;
            message.is_deleted = false;
          },
          error: () => this.toastr.error("Failed to restore comment"),
          complete: () => {
            this.cdr.detectChanges();
            console.log("toggleClientTaskMessageVisibility, cmoplete");
          },
        });
    }
    console.log("toggleClientTaskMessageVisibility, finish");
  }

  async pinMessage(message) {
    if (message["pinned"] == "completed") {
      this.bsModalRef = this.modalService.show(this.removePinModal, {
        class: "modal-sm",
      });
      return;
    }
    this.loadingPin = true;
    let pinned = await this.chatService.pinMessage(
      message,
      this.conversation_uuid,
      this.company_uuid,
    );
    this.loadingPin = false;
    message["pinned"] = pinned;
    this.handleBubbleClass();
    this.cdr.detectChanges();
  }

  updateMessagePinStatus() {}

  async removePin(message) {
    this.loadingPin = true;
    let pinned = await this.chatService.pinMessage(
      message,
      this.conversation_uuid,
      this.company_uuid,
    );
    message["pinned"] = pinned;
    this.loadingPin = false;
    this.handleBubbleClass();
    this.cdr.detectChanges();
    this.bsModalRef.hide();
  }

  openRemovePinModal(template: TemplateRef<any>): void {
    this.bsModalRef = this.modalService.show(template, { class: "modal-sm" });
  }

  addReply(message) {
    this.chatService.setReplyingTo.next(message);
  }

  getProfilePicture(user_id) {
    return this.conversationsService.getProfilePicture(user_id);
  }

  handleBubbleClass() {
    if (
      (this.message.tracked_item != null && !this.is_comment) ||
      this.message.reminder
    ) {
      this.bubbleClass = "is-status-message";
    } else {
      if (this.message.sent_by != null || this.is_comment) {
        if (this.message.sent_by.id == this.user.id) {
          this.bubbleClass = "me";
          this.replyBubbleClass = "others";
        } else {
          this.bubbleClass = "others";
          this.replyBubbleClass = "me";
        }
      }
    }

    if (
      this.data.user_type == 1 &&
      (this.message.pinned == true || this.message.pinned == "pinned")
    ) {
      this.bubbleClass = this.bubbleClass + " pinned";
    }

    if (this.data.user_type == 1 && this.message.pinned == "completed") {
      this.bubbleClass = this.bubbleClass + " pinned completed";
    }
  }

  createJobFromMessage() {
    if (this.data.tier != "pro") {
      this.router.navigate([], {
        fragment: "jobsTab",
        queryParams: {},
      });
      return;
    }

    const job = new Job();

    job.name = "Job created from Client Message";
    job.client_company = this.conversation_uuid;

    this.jobsService
      .createJobFromMessage(job, this.message.message, this.message)
      .subscribe(
        async (res) => {
          await this.handleJobCreationSuccess(res);
          this.jobsStore.changeSelectedJob.next(res.job);
        },
        (err) => this.handleError(err),
      );
  }

  async handleJobCreationSuccess(res: any) {
    console.log("THE RES", res);
    this.toastr.success(res.message);
    // this.jobsStore.changeSelectedJob.next(job);
    // job?=res.uuid
    this.router.navigate([], {
      fragment: "jobsTab",
      queryParams: {},
    });
  }

  handleError(err: any) {
    this.toastr.error(err.error.message);
  }

  canTakeAction(): boolean {
    if (!this.isAccountant()) return false; // only accountants have access
    if (this.isDeleted() && !this.isSender()) return false; // can restore only own messages
    return true;
  }

  // status
  isAccountant(): boolean {
    return this.data.user_type == 1;
  }
  isSender(): boolean {
    return this.message.sent_by.id === this.user.id;
  }
  isDeleted(): boolean {
    return this.message["deleted"] || this.message["is_deleted"];
  }

  // actions
  canCreateJob(): boolean {
    return (
      !this.isDeleted() &&
      this.isAccountant() &&
      this.message.tracked_item === null
    );
  }
  canRestore(): boolean {
    return this.isDeleted() && this.isAccountant() && this.isSender();
  }
  canEdit(): boolean {
    return !this.isDeleted() && this.isSender();
  }
  canDelete(): boolean {
    return !this.isDeleted() && this.isSender();
  }
  canReply(): boolean {
    return !this.is_comment;
  }
}
